import type { VoluntaryEmailAdmission, VoluntaryEmailDetail } from "@kollectivia/shared/schemas";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

export function useImportVoluntaryEmail() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: ({ file, key }: { file: File; key: string }) =>
      api.postEmail<VoluntaryEmailAdmission>(
        `/v1/voluntary-emails?declared_channel=ui&idempotency_key=${encodeURIComponent(key)}`,
        file,
      ),
    onSuccess: () => {
      void qc.invalidateQueries({ queryKey: ["intake-events"] });
    },
  });
}
export function useVoluntaryEmail(id: string) {
  return useQuery({
    queryKey: ["voluntary-email", id],
    queryFn: () => api.get<VoluntaryEmailDetail>(`/v1/voluntary-emails/${encodeURIComponent(id)}`),
  });
}
